import { LinearProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useStyles } from '../styles/headerStyles';
import { useProject } from '../context';
import { isStakeholder } from '../../../../../utils/share';
import ProjectName from './ProjectName';
import BreadCrumb from '../../../../../components/breadcrumb/BreadCrumbNavigation';
import { getTaskClassificationList } from '../../../../../services/taskClassification';
import { getCurrentSprint } from '../../../../../utils/projectHealth';

const Header = () => {
  const classes = useStyles();
  const { projectDetails } = useProject();
  const userIsStakeholder = isStakeholder();
  const budgetHrs = projectDetails?.totalHrs;
  const [currentSprint, setCurrentSprint] = useState(null);
  const consumedHrs = projectDetails?.projectmember?.reduce((sum, member) => sum + member?.totalTime / 3600, 0) ?? 0;
  // const remainingHrs = `${((budgetHrs ?? 0) - (consumedHrs ?? 0)).toFixed(0)} / ${(budgetHrs ?? 0).toFixed(0)}`;
  // const remainingHrs = `${((budgetHrs ?? 0) - (consumedHrs ?? 0)).toFixed(0)} / ${(budgetHrs ?? 0).toFixed(0)}`;
  const remainingHrs = `${(consumedHrs ?? 0).toFixed(0)} / ${(budgetHrs ?? 0).toFixed(0)}`;
  const hoursLeft = (budgetHrs - consumedHrs).toFixed(0);
  const projectPercentage =
    projectDetails?.totalHrs === 0
      ? 0
      : ((parseInt(projectDetails?.totalTime, 10) / 3600) * 100) / projectDetails?.totalHrs;

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'Projects',
      path: '/projects',
    },
    {
      label: 'Project Details',
      path: '',
    },
  ];
  async function getCurrent() {
    try {
      const response = await getTaskClassificationList({ pageSize: 'all', projectId: projectDetails?.id });
      const current = getCurrentSprint(response?.data?.data?.rows);
      setCurrentSprint(current);
      return null;
    } catch (error) {
      console.error('Error fetching current sprint:', error);
      return null;
    }
  }
  useEffect(() => {
    getCurrent();
  }, []);

  return (
    <Stack direction="row" justifyContent="space-between" spacing={2} style={{ marginBottom: '20px' }}>
      <Stack>
        <Stack alignItems="center">
          <BreadCrumb breadcrumbs={breadcrumbs} />
        </Stack>
        <Stack>
          <Typography variant="h4">
            <ProjectName />
          </Typography>
        </Stack>
      </Stack>
      <Stack className={classes.rightSection} direction="row" alignItems="center" spacing={2}>
        <Stack direction="column" spacing={0}>
          <Typography variant="h6" textAlign="center">
            {currentSprint?.name || 'N/A'}
          </Typography>
          <Typography variant="subtitle2" textAlign="center">
            Current Sprint
          </Typography>
        </Stack>
        {!userIsStakeholder && (
          <>
            <Stack alignItems="flex-start">
              <Stack direction="row" spacing={1}>
                <LinearProgress
                  variant="determinate"
                  value={projectPercentage > 100 ? 100 : projectPercentage}
                  color={projectPercentage < 71 ? 'success' : projectPercentage < 91 ? 'warning' : 'error'}
                  sx={{
                    height: 20,
                    width: '150px',
                    border: projectPercentage < 91 ? undefined : '1px solid #e43b3b',
                  }}
                />
                <Typography
                  variant="body2"
                  className={classes.typographyVariant2}
                  color="text.secondary"
                >{`${Math.round(projectPercentage)}%`}</Typography>
              </Stack>
              <Stack>
                <Typography variant="subtitle2" textAlign="center" sx={{ paddingLeft: '17px' }}>
                  Consumption (%)
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Stack alignItems="center">
                <Typography variant="h6" textAlign="center">
                  {remainingHrs}
                </Typography>
                <Typography variant="subtitle2" textAlign="center">
                  Consumed Hours
                </Typography>
              </Stack>
              <Stack alignItems="center">
                <Typography variant="h6" textAlign="center">
                  {hoursLeft || 0}
                </Typography>
                <Typography variant="subtitle2" textAlign="center">
                  Hours Left
                </Typography>
              </Stack>
            </Stack>
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default Header;
